import {PlatformComponentContext} from 'src/components/PlatformContext/types';
import LaunchScreen from 'src/apps/mobile/pages/LaunchScreen/LaunchScreen';

const ionicContext: PlatformComponentContext = {
  LaunchScreen: LaunchScreen,
};

export default ionicContext;
